import { getDossierChartData } from "../../../../api/dossier/getDossierChartData";
import { DossierSavingsDatum } from "../../../../types/Chart";
import { CRMAppLocationIdentifier, FaqProps } from "../../../../types/Faq";
import APChart from "../APChart";
import DossierSavingsTotals from "./DossierSavingsTotals";

const DossierSavingsChart = ({
  dossierId,
  showTotals,
  faqs,
  faqAppLocationIdentifiers,
}: {
  dossierId: string;
  showTotals: boolean;
  faqs: FaqProps;
  faqAppLocationIdentifiers: {
    gstSavings: CRMAppLocationIdentifier;
    incomeTaxSavings: CRMAppLocationIdentifier;
    totalSavings: CRMAppLocationIdentifier;
  };
}) => {
  const { data, isSuccess } = getDossierChartData<DossierSavingsDatum>(
    dossierId,
    "dossier-savings"
  );

  return (
    <APChart
      key={dossierId}
      type="line"
      chartTitle="Savings"
      getData={() =>
        getDossierChartData<DossierSavingsDatum>(dossierId, "dossier-savings")
      }
      xAxisOptions={{ type: "time" }}
      yAxisOptions={{ type: "currency" }}
      dimensions={[
        { key: "date", label: "Date" },
        { key: "gstSavings", label: "GST Savings" },
        { key: "incomeTaxSavings", label: "Income Tax Savings" },
      ]}
      isAreaChart={true}
      isStacked={true}
      totalsRenderer={
        showTotals
          ? () => (
              <DossierSavingsTotals
                gstSavings={
                  isSuccess
                    ? data?.[data.length - 1]?.gstSavings || 0
                    : undefined
                }
                incomeTaxSavings={
                  isSuccess
                    ? data?.[data.length - 1]?.incomeTaxSavings || 0
                    : undefined
                }
                faqs={faqs}
                faqAppLocationIdentifiers={faqAppLocationIdentifiers}
              />
            )
          : undefined
      }
    />
  );
};

export default DossierSavingsChart;
